import Vue from 'vue'
import VueRouter from 'vue-router'
import { AppConstants as _app } from '@/shared/app.constants';
import DashboardComponents from '../components/App/Assets/Dashboard.vue';
import WorkspaceComponent from '../components/App/Modules/GMS/Workspace/Workspace.vue';
import ApplicationTabsComponent from '../components/App/Modules/GMS/Admin/Dashboard/ApplicationTabs.vue';
import ConceptNoteWorkspaceComponent from '../components/App/Modules/GMS/ConceptNote/Workspace/Workspace.vue';
import ApplicationLayoutComponent from '../components/App/Modules/GMS/Admin/Dashboard/ApplicationLayout.vue';
import ApplicationTableComponent from '../components/App/Modules/GMS/Admin/Dashboard/ApplicationTableList.vue';
import AdminApplicationSummaryComponent from '../components/App/Modules/GMS/Admin/Dashboard/ApplicationSummary.vue';
import ApplicantDashboardComponent from '@/components/App/Modules/GMS/Applicant/ApplicantDashboard.vue';
import ApplicantTabsComponent from '../components/App/Modules/GMS/Applicant/ApplicantTabs.vue';
import RegistrationComponent from '../components/App/Modules/Authentication/Registration.vue';
import AuthService from './../services/auth.service';
import RouterService from './../services/router.service';
import ProposalCallsFilterComponent from '../components/App/Modules/GMS/Applicant/ProposalCallsFilter/ProposalCallsFilter.vue';
import HomePageComponent from '../components/App/Modules/GMS/Applicant/HomePage/HomePage.vue';
import ArchiveListComponent from '../components/App/Modules/GMS/Applicant/HomePage/ArchiveList.vue';

import { NavigationStack } from '@/entities';
import InternalDashboardComponent from '@/components/App/Modules/GMS/Dashboard/Internal.vue'
import NotificationComponent from '@/components/App/Modules/GMS/Admin/NotificationTable/NotificationComponent.vue'
import ExternalDashboardComponent from '@/components/App/Modules/GMS/Dashboard/External.vue'
import InternalUserDashboardComponent from '@/components/App/Modules/GMS/Dashboard/InternalDashboard.vue';
import ExternalUserDashboardComponent from '@/components/App/Modules/GMS/Dashboard/ExternalDashboard.vue';

import ProposalCallsComponent from '../components/App/Modules/GMS/Applicant/ProposalCalls/ProposalCalls.vue';
import ApplicantDeclarationComponent from '../components/App/Modules/GMS/Applicant/HomePage/ApplicantDeclaration/ApplicantDeclaration.vue';
import ConceptNoteDeclarationComponent from '../components/App/Modules/GMS/ConceptNote/Declaration.vue';
import IndicatorsComponent from '../components/App/Modules/GMS/Admin/Indicators/Indicators.vue';
import SummaryComponent from '../components/App/Modules/GMS/Applicant/Summary/Summary.vue'
import { User } from 'oidc-client';
const auth = new AuthService();
const routerService = new RouterService();
import ReviewFormComponent from '../components/App/Modules/GMS/Reviewer.External/ReviewForm/ReviewForm.vue';
import GenericNotificationComponent from '../components/common/GenericNotification/GenericNotification.vue';
import COIDeclarationComponent from '../components/App/Modules/GMS/Reviewer.External/Dashboard/COIDeclaration.vue';
import ReviewerDashboardComponent from '../components/App/Modules/GMS/Reviewer.External/Dashboard/ExternalReviewerDashboard.vue';
import InternalReviewWorkspace from '@/components/App/Modules/GMS/Review.Internal/Workspace/InternalReviewWorkspace.vue';
import ReadOnlyInternalReviewWorkspace from '@/components/App/Modules/GMS/Review.Internal/Workspace/ReadonlyInternalReviewWorkspace.vue';
import BudgetReviewWorkspace from '@/components/App/Modules/GMS/Review.Internal/Workspace/BudgetReviewWorkspace.vue';
import ReadOnlyBudgetReviewWorkspace from '@/components/App/Modules/GMS/Review.Internal/Workspace/ReadonlyBudgetReviewWorkspace.vue';
import InternalReviewerDashboardComponent from '@/components/App/Modules/GMS/Review.Internal/Dashboard/InternalReviewerDashboard.vue';
import GrantListComponent from '@/components/App/Modules/GMS/Grants/GrantList.vue';
import CommunicationListComponent from '@/components/App/Modules/GMS/Communication/CommunicationList.vue';
import CommunicationTrackerComponent from '@/components/App/Modules/GMS/Communication/CommunicationTracker.vue';
import CommunicationDocumentComponent from '@/components/App/Modules/GMS/Communication/CommunicationDocuments.vue';
import CommunicationTrackerFormComponent from '@/components/App/Modules/GMS/Communication/Tracker/Workspace.vue';
import GrantDashboard from '@/components/App/Modules/GMS/Grants/GrantDashboard/GrantDashboard.vue';
import CommunicationDashboard from '@/components/App/Modules/GMS/Communication/Dashboard.vue';
import CommunicationWorkspace from '@/components/App/Modules/GMS/Communication/Workspace.vue';
import ImpactReportComponent from '@/components/App/Modules/GMS/Reports/ImpactReport.vue';
import BudgetReportComponent from '@/components/App/Modules/GMS/Reports/BudgetReports/Workspace.vue';
import GpouSummaryComponent from '@/components/App/Modules/GMS/Review.Internal/Workspace/GpouSummary.vue';
import ReadOnlyGpouSummaryComponent from '@/components/App/Modules/GMS/Review.Internal/Workspace/ReadOnlyGpouSummary.vue';
import ReadonlyApplicationFormComponent from '@/components/App/Modules/GMS/Workspace/ReadonlyApplicationForm.vue';
import UserInformationComponent from '@/components/App/Modules/GMS/Admin/EditProfile/UserInformation.vue';
import ReadOnlyTAGReviewComponent from '@/components/App/Modules/GMS/Reviewer.External/ReviewForm/ReadOnlyTAGReview.vue';
import LanguageManagerComponent from '@/components/App/Modules/GMS/Admin/LanguageManager/LanguageManager.vue';
import { AbilityBuilder } from '@casl/ability';
import SnapshotViewComponent from '@/components/App/Modules/GMS/Workspace/SnapshotView.vue';
import ConceptNoteSnapshotViewComponent from '@/components/App/Modules/GMS/ConceptNote/Workspace/SnapshotView.vue';
import GrantSummaryComponent from '@/components/App/Modules/GMS/Grants/GrantSummary.vue';
import GrantAgreementComponent from '@/components/App/Modules/GMS/Grants/GrantAgreement.vue';
import AppReviewLayoutComponent from '@/components/App/Modules/GMS/Admin/Dashboard/AppReviewLayout.vue';
import GrantAgreementReadOnly from '@/components/App/Modules/GMS/Grants/GrantAgreementReadOnly.vue';
import GrantMonitoring from '@/components/App/Modules/GMS/Grants/Monitoring.vue';
import TechnicalReport from '@/components/App/Modules/GMS/Grants/TechnicalReport/Workspace.vue';
import FinalTechnicalReportComponent from '@/components/App/Modules/GMS/Grants/TechnicalReport/FinalReport.vue';
import FinancialReport from '@/components/App/Modules/GMS/Grants/FinancialReport/Workspace.vue';
import ReviewApplicationSummary from '@/components/App/Modules/GMS/Reviewer.External/Dashboard/ReviewSummary.vue';
import ReportDashboardComponent from '@/components/App/Modules/GMS/Reports/ReportDashboard.vue';
import TemplateManagerComponent from '@/components/App/Modules/GMS/Admin/TemplateManager/TemplateManager.vue';
import UnauthorizedComponent from '@/components/common/Unauthorized/Unauthorized.vue';
import DownloadComponent from '@/components/App/Modules/GMS/Workspace/Components/BudgetDownload.vue';
import ArchiveComponent from '@/components/App/Modules/GMS/Admin/ArchiveManager/ArchiveManager.vue'
import CreateArchiveComponent from '@/components/App/Modules/GMS/Admin/ArchiveManager/CreateArchive.vue';
import UpdateArchiveComponent from '@/components/App/Modules/GMS/Admin/ArchiveManager/UpdateArchive.vue';
import UsefulDocListComponent from '@/components/App/Modules/GMS/Applicant/HomePage/UsefulDocsList.vue';
import MigrationImportComponent from '@/components/App/Modules/GMS/Migration/Import.vue';
import CommunicationsComponent from '@/components/App/Modules/GMS/Admin/commiunications/Index.vue'
import MigrationListComponent from '@/components/App/Modules/GMS/Migration/MigrationList.vue';
import CommunicationSummaryComponent from '@/components/App/Modules/GMS/Communication/Summary.vue';
import CommunicationApplicantSummaryComponent from '@/components/App/Modules/GMS/Communication/ApplicantSummary.vue';

import ConceptNoteSummaryLayoutComponent from '../components/App/Modules/GMS/ConceptNote/Summary/SummaryLayout.vue';
import ConceptNoteSummaryComponent from '../components/App/Modules/GMS/ConceptNote/Summary/Components/ApplicantSummary.vue'
import ReviewTabsComponent from '@/components/App/Modules/GMS/Admin/Dashboard/ReviewTabs.vue';
import ExternalReviewerTabsComponent from '@/components/App/Modules/GMS/Reviewer.External/ReviewerTabs.vue';
import PublicContactComponent from '@/components/App/Modules/GMS/Contact/PublicContact.vue';
import PrivateContactComponent from '@/components/App/Modules/GMS/Contact/PrivateContact.vue';
import AmendmentWorkspaceComponent from '@/components/App/Modules/GMS/Amendment/Workspace.vue';
import AmendmentDetailWorkspaceComponent from '@/components/App/Modules/GMS/Amendment/Components/Workspace.vue';

Vue.use(VueRouter)

const appRoles = _app.appRoles;

const appUserType = _app.appUserType;
const roles = _app.roles;
var navigationStack = new NavigationStack();

const routes = [
  {
    path: '/',
    name: "home",
    component: HomePageComponent,
    meta: {
      layout: 'public'
    }
  },
  {
    path: '/UsefulDocsList',
    name: "UsefulDocListComponent",
    component: UsefulDocListComponent,
    meta: {
      layout: 'public',
      isAnonymous: true,
    }
  },
  {
    path: '/ArchiveList',
    name: "ArchiveListComponent",
    component: ArchiveListComponent,
    meta: {
      layout: 'public',
      isAnonymous: true,
    }
  },
  {
    path: "/Admin/Program/AdminApplicationDashboard/AdminApplicationDashboardForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/UsefulDocument/UsefulDocumentForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/UsefulDocument",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: '/Admin/Communication/Template Mapping/CallCommunicationTemplate',
    name: "CommunicationsComponent",
    component: CommunicationsComponent,
    meta: {
      layout: 'admin',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.CommunicationOfficer
      ]
    }
  },
  {
    path: '/gmsdashboard',
    name: "gmsdashboard",
    component: () => {
      return auth.isLoggedIn().then((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          return auth.getUser().then((user: User) => {
            switch (user.profile.user_type) {
              case appUserType.System:
              case appUserType.SystemAdmin:
              case appUserType.Secretariat:
                return InternalUserDashboardComponent;

              case appUserType.TAGReviewer:
              case appUserType.LeadPartner:
              case appUserType.Auditor:
                return ExternalUserDashboardComponent;
            }
          });
        }
      });
    },
    meta: {
      layout: 'menu',
      menuName: 'Dashboard',
      sortOrder: 1,
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin,
        appRoles.SecretariatMember,
        appRoles.Reviewer,
        appRoles.Applicant,
        appRoles.GPOU,
        appRoles.RagReviewer,
        appRoles.Auditor
      ]
    },
  },
  {
    path: '/dashboard',
    name: "dashboard",
    component: () => {
      // sets default component based on the user type
      return auth.isLoggedIn().then((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          return auth.getUser().then((user: User) => {
            switch (user.profile.user_type) {
              case appUserType.TAGReviewer:
                return ExternalReviewerTabsComponent;

              case appUserType.LeadPartner:
                return ApplicantTabsComponent;

              // case appUserType.Auditor:
              //   return ApplicantDashboardComponent;

              case appUserType.System:
              case appUserType.SystemAdmin:
              case appUserType.Secretariat:
                return ApplicationTabsComponent;
            }
          });
        }
      });
    },
    meta: {
      layout: 'menu',
      menuName: 'Applications',
      sortOrder: 1,
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin,
        appRoles.SecretariatMember,
        appRoles.Reviewer,
        appRoles.Applicant,
        appRoles.GPOU,
        appRoles.RagReviewer
      ]
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: UserInformationComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.InitiativeAdmin,
        appRoles.Applicant,
        appRoles.GPOU,
        appRoles.Reviewer,
        appRoles.RagReviewer,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/GMS/Application/:appId/Snapshot/:logId/:section?',
    name: 'snapshot',
    component: SnapshotViewComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.Applicant
      ]
    }
  },
  {
    path: '/GMS/Grant/:grantId/Summary',
    name: 'grantSummary',
    component: () => {
      // sets default component based on the user type
      return auth.isLoggedIn().then((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          return auth.getUser().then((user: User) => {
            switch (user.profile.user_type) {
              case appUserType.TAGReviewer:
                return GrantSummaryComponent;

              case appUserType.LeadPartner:
                return GrantMonitoring;

              case appUserType.Auditor:
                return GrantMonitoring;

              case appUserType.System:
              case appUserType.SystemAdmin:
              case appUserType.Secretariat:
                return GrantSummaryComponent;
            }
          });
        }
      });
    },
    //component: GrantSummaryComponent,
    meta: {
      layout: 'menu',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/GMS/Grant/:grantId/Agreement',
    name: 'grantAgreement',
    component: GrantAgreementComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.Applicant
      ]
    }
  },
  {
    path: '/Admin/Program/ArchiveCall',
    name: 'ArchiveComponent',
    component: ArchiveComponent,
    meta: {
      layout: 'admin',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
      ]
    }
  },
  {
    path: '/Admin/Program/ArchiveCall/CreateArchive',
    name: 'CreateArchiveComponent',
    component: CreateArchiveComponent,
    meta: {
      layout: 'admin',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
      ]
    }
  },
  {
    path: '/Admin/Program/ArchiveCall/UpdateArchive',
    name: 'UpdateArchiveComponent',
    component: UpdateArchiveComponent,
    meta: {
      layout: 'admin',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
      ]
    }
  },
  {
    path: '/GMS/Grant/:grantId/Agreement/ReadOnly',
    name: 'grantAgreementReadOnly',
    component: GrantAgreementReadOnly,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.Applicant
      ]
    }
  },
  {
    path: '/GMS/Monitor/TechnicalReport/:technicalReportId',
    name: 'technicalReport',
    component: TechnicalReport,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/GMS/Monitor/FinalTechnicalReport/:technicalReportId',
    name: 'finalTechnicalReport',
    component: FinalTechnicalReportComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/GMS/Monitor/FinancialReport/:financialReportId',
    name: 'financialReport',
    component: FinancialReport,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/GMS/Communication/:communicationId/ReportingPeriods',
    name: 'communicationReportingPeriods',
    component: () => import("@/components/App/Modules/GMS/Communication/CommunicationReportingPeriods.vue"),
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.Auditor
      ]
    },
  },
  {
    path: '/GMS/Communication/:communicationId/Reports',
    name: 'communicationReports',
    component: CommunicationWorkspace,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    },
    beforeEnter: (to, from, next) => {
      // Condition based redirection
      routerService.checkCommunicationStarted(to, from)
        .then((data: any) => {
          if (data) {
            next();
          } else {
            next({
              name: 'communicationReportingPeriods',
              params: to.params
            });
          }
        });
    }
  },
  {
    path: '/Admin/System/Notification',
    name: 'NotificationComponent',
    component: NotificationComponent,
    meta: {
      layout: 'admin',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
      ]
    }
  },
  {
    path: '/calls',
    name: 'callForProposal',
    component: ProposalCallsComponent,
    meta: {
      layout: 'menu',
      menuName: 'Calls',
      sortOrder: 2,
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.Applicant
      ]
    }
  },
  {
    path: '/Application/:appId/View/:section?',
    component: ReadonlyApplicationFormComponent,
    name: "viewApplication",
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.Reviewer,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin,
        appRoles.SecretariatMember,
        appRoles.GPOU,
        appRoles.RagReviewer,
        appRoles.Auditor,
        appRoles.Applicant
      ]
    }
  },
  {
    path: '/ViewTagReview',
    component: ReadOnlyTAGReviewComponent,
    name: "viewTagReview",
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.Reviewer,
        appRoles.SecretariatMember,
        appRoles.ProgramAdmin,
        appRoles.RagReviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    /** new user registration page - anonymous access */
    path: '/grants',
    name: 'Grants',
    component: GrantDashboard, //GrantListComponent,
    meta: {
      layout: 'menu',
      menuName: 'Grants',
      sortOrder: 4,
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.GPOU,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
  {
    /** new communication page */
    path: '/communication',
    name: 'Communication',
    component: () => {
      // sets default component based on the user type
      return auth.isLoggedIn().then((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          return auth.getUser().then((user: User) => {
            switch (user.profile.user_type) {
              // case appUserType.LeadPartner:
              //   return CommunicationApplicantSummaryComponent;;
              case appUserType.System:
              case appUserType.SystemAdmin:
              case appUserType.Secretariat:
                return CommunicationSummaryComponent;;
            }
          });
        }
      });
    },
    meta: {
      layout: 'menu',
      menuName: 'Communication',
      sortOrder: 5,
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.GPOU
      ]
    }
  },
  {
    path: '/communication/list',
    name: 'communicationList',
    component: CommunicationListComponent,
    meta: {
      layout: 'menu',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.GPOU,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/communication/tracker',
    name: 'communicationTracker',
    component: CommunicationTrackerComponent,
    meta: {
      layout: 'menu',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.GPOU
      ]
    }
  },
  {
    path: '/communication/docs',
    name: 'communicationDocs',
    component: CommunicationDocumentComponent,
    meta: {
      layout: 'menu',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.GPOU
      ]
    }
  },
  {
    path: '/communication/tracker/:communicationId',
    name: 'communicationTrackerForm',
    component: CommunicationTrackerFormComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.GPOU
      ]
    }
  },
  {
    path: '/GMS/Application/:applicationId/Summary',
    name: 'applSummary',
    component: SummaryComponent,
    meta: {
      layout: 'menu',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/GMS/ApplicationSummary/:applicationId',
    name: 'applicationSummary',
    component: AdminApplicationSummaryComponent,
    meta: {
      layout: 'menu',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.InitiativeAdmin,
        appRoles.RagReviewer,
        appRoles.Reviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    /** new user registration page - anonymous access */
    path: '/Registration',
    component: RegistrationComponent,
    meta: {
      isAnonymous: true,
    }
  },
  {
    /** Internal review */
    path: '/GMS/DueDiligenceReview/:entity/:applicationId',
    name: "internalReview",
    component: InternalReviewWorkspace,
    meta: {
      // layout: 'menu',
      // menuName: 'Reviews',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.SecretariatMember,
        appRoles.ProgramAdmin,
        appRoles.RagReviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    /** Internal review */
    path: '/GMS/ReadOnlyDueDiligenceReview/:entity/:applicationId',
    name: "ReadonlyinternalReview",
    component: ReadOnlyInternalReviewWorkspace,
    meta: {
      // layout: 'menu',
      // menuName: 'Reviews',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.SecretariatMember,
        appRoles.ProgramAdmin,
        appRoles.RagReviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    /* Internal review */
    path: '/InternalReviews',
    name: "internalReviews",
    // component: InternalReviewerDashboardComponent,
    component: ReviewTabsComponent,
    meta: {
      layout: 'menu',
      menuName: 'Reviews',
      sortOrder: 3,
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        // appRoles.SecretariatMember,
        appRoles.ProgramAdmin,
        appRoles.RagReviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    /** Budget review */
    path: '/GMS/BudgetReview/:entity/:applicationId',
    name: "budgetReview",
    component: BudgetReviewWorkspace,
    meta: {
      // layout: 'menu',
      // menuName: 'Reviews',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.SecretariatMember,
        appRoles.ProgramAdmin,
        appRoles.RagReviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    /** Budget review */
    path: '/GMS/ReadOnlyBudgetReview/:entity/:applicationId',
    name: "readOnlyBudgetReview",
    component: ReadOnlyBudgetReviewWorkspace,
    meta: {
      // layout: 'menu',
      // menuName: 'Reviews',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.SecretariatMember,
        appRoles.ProgramAdmin,
        appRoles.RagReviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    /** Internal review summary*/
    path: '/GMS/InternalReviewSummary/:entity/:applicationId',
    name: "internalReviewSummary",
    component: GpouSummaryComponent,
    meta: {
      layout: 'menu',
      // menuName: 'Reviews',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.SecretariatMember,
        appRoles.ProgramAdmin,
        appRoles.RagReviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    /** Internal review summary*/
    path: '/GMS/ReadOnlyInternalReviewSummary/:entity/:applicationId',
    name: "readOnlyInternalReviewSummary",
    component: ReadOnlyGpouSummaryComponent,
    meta: {
      layout: 'menu',
      // menuName: 'Reviews',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.SecretariatMember,
        appRoles.ProgramAdmin,
        appRoles.RagReviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    path: '/Review/:entity/:reviewerId/Application/:applicationId',
    component: ReviewFormComponent,
    name: "reviewApplication",
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.Reviewer,
        appRoles.RagReviewer
      ]
    },
    beforeEnter: (to, from, next) => {
      // Condition based redirection
      routerService.IsRecordExist(to, from)
        .then((data: any) => {
          if (data && data.review && data.review.WorkFlowStatusId == _app.reviewStatus.Submitted) {
            next({
              name: 'genericNotification',
              query: { msgId: "reviewSubmitted" }
            });
          } else if (data == null) {
            next({
              name: 'TagReviewerDeclaration',
              params: to.params
            });
          } else {
            next();
          }
        });
    }
  },
  {
    path: '/ReviewSummary',
    component: ReviewApplicationSummary,
    name: "reviewSummary",
    meta: {
      allowedRoles: [
        appRoles.Reviewer
      ]
    }
  },
  {
    /** new user registration page - anonymous access */
    path: '/reports',
    component: ReportDashboardComponent,
    meta: {
      layout: 'menu',
      menuName: 'Reports',
      sortOrder: 5,
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.RagReviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    path: '/reports/impact',
    name: 'impactReports',
    component: ImpactReportComponent,
    meta: {
      layout: 'menu',
      sortOrder: 5,
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.RagReviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    path: '/reports/budget/:report?',
    name: 'budgetReports',
    component: BudgetReportComponent,
    meta: {
      layout: 'menu',
      sortOrder: 5,
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.RagReviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    /** application form */
    path: "/GMS/Application/:applicationId/ApplicationForm/:section?",
    name: "applicantapply",
    component: WorkspaceComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
  {
    path: "/Admin",
    name: "admin",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin
      ]
    }
  },
  {
    path: "/Admin/System/User",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/User/UserForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.hash == "#0") {
        return;
      }

      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/Role",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/Role/RoleForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/UserGroups",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/UserGroups/UserGroupsForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/WorkFlowDefinition",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/WorkFlowDefinition/WorkFlowDefinitionForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.hash == "#0") {
        return;
      }

      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/WorkFlowDefinition/WorkFlowStepMapping",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.hash == "#0") {
        return;
      }

      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/WorkFlowDefinition/WorkFlowDefinitionForm/WorkFlowStepForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.hash == "#0") {
        return;
      }

      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/WorkFlowDefinition/WorkFlowDefinitionForm/WorkFlowModelForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.hash == "#0") {
        return;
      }

      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/WorkFlowService",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/System/WorkFlowService/WorkFlowServiceForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.hash == "#0") {
        return;
      }

      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/Initiative",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/Initiative/InitiativeForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/InitiativeCall",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/InitiativeCall/InitiativeCallForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/Donor",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/Donor/DonorForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/ReviewCategory",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/ReviewCategory/ReviewCategoryForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/MeIndicatorMapping",
    component: IndicatorsComponent,
    meta: {
      layout: 'admin',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.MEAdmin
      ]
    }
  },
  {
    path: "/Admin/Program/MEIndicator",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.MEAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/MEIndicator/MEIndicatorForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.MEAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/MEIndicator/MEIndicatorForm/MEIndicatorMeasure/MEIndicatorMeasureForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.MEAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
        // history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/ReviewPanel",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/ReviewPanel/ReviewPanelForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: '/ProposalCallsFilter',
    component: ProposalCallsFilterComponent,
    meta: {
      isAnonymous: true,
    }
  },
  {
    path: '/ApplicantDeclaration',
    name: _app.RouteAlias.applicantDeclaration,
    component: ApplicantDeclarationComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.Applicant
      ]
    }
  },
  {
    path: '/TagReviewerDeclaration/:entity/:reviewerId/Application/:applicationId',
    name: 'TagReviewerDeclaration',
    component: COIDeclarationComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.Reviewer,
        appRoles.RagReviewer
      ]
    }
  },
  {
    path: '/Notifications',
    component: GenericNotificationComponent,
    name: "genericNotification",
    meta: {
      isAnonymous: true,
    }
  },
  {
    path: '/Admin/System/LanguageManager',
    component: LanguageManagerComponent,
    name: "LanguageManager",
    meta: {
      layout: 'admin',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
      ]
    }
  },
  {
    path: '/Admin/System/Template',
    component: TemplateManagerComponent,
    name: "Template",
    meta: {
      layout: 'admin',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin
      ]
    }
  },
  {
    path: '/unauthorized',
    component: UnauthorizedComponent,
    name: "Unauthorized",
    meta: {
      isAnonymous: true,
    }
  },
  {
    path: '/download/:type/:appId/:entity?',
    component: DownloadComponent,
    name: "Download",
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.InitiativeAdmin,
        appRoles.Applicant,
        appRoles.GPOU,
        appRoles.Reviewer,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/Migrations',
    component: MigrationListComponent,
    name: "Migrations",
    meta: {
      layout: 'menu',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember
      ]
    }
  },
  {
    path: '/Migration/:id',
    component: MigrationImportComponent,
    name: "Migration",
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember
      ]
    }
  },
  {
    path: '/ConceptNote/Declaration',
    name: _app.RouteAlias.conceptNoteDeclaration,
    component: ConceptNoteDeclarationComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.Applicant
      ]
    }
  },
  {
    /** concept note form */
    path: "/GMS/ConceptNote/:conceptNoteId/ConceptNoteForm/:section?",
    name: "conceptnoteapply",
    component: ConceptNoteWorkspaceComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/ConceptNote/:conceptNoteId/Summary',
    name: 'conceptNoteSummary',
    component: ConceptNoteSummaryLayoutComponent,
    meta: {
      layout: 'menu',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.InitiativeAdmin,
        appRoles.RagReviewer,
        appRoles.Reviewer,
        appRoles.GPOU
      ]
    }
  },
  {
    path: '/GMS/ConceptNote/:conceptNoteId/Summary',
    name: 'applConceptNoteSummary',
    component: ConceptNoteSummaryComponent,
    meta: {
      layout: 'menu',
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/ConceptNote/:conceptNoteId/View/:section?',
    component: ConceptNoteWorkspaceComponent,
    name: "viewConceptNote",
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.Reviewer,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin,
        appRoles.SecretariatMember,
        appRoles.GPOU,
        appRoles.RagReviewer,
        appRoles.Auditor,
        appRoles.Applicant
      ]
    }
  },
  {
    path: '/ConceptNote/:conceptNoteId/Snapshot/:logId/:section?',
    name: 'snapshotConceptNote',
    component: ConceptNoteSnapshotViewComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.Applicant
      ]
    }
  },
  {
    path: "/Admin/Program/Contact",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + to.query.mId)
      } else {
        next()
      }
    }
  },
  {
    path: "/Admin/Program/Contact/ContactForm",
    component: DashboardComponents,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.InitiativeAdmin
      ]
    },
    beforeEnter: (to, from, next) => {
      if (from.matched.length) {
        history.pushState({}, "", to.path + '?mId=' + (to.query.mId + (to.hash != '' ? to.hash : '')))
      } else {
        next()
      }
    }
  },
  {
    path: "/ContactInfo",
    component: PublicContactComponent,
    meta: {
      isAnonymous: true,
      layout: 'public'
    }
  },
  {
    path: "/Contact",
    component: PrivateContactComponent,
    meta: {
      layout: 'menu',
      menuName: 'Contacts',
      sortOrder: 8,
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.Applicant,
        appRoles.SecretariatMember,
        appRoles.Reviewer,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/GMS/Grant/Amendment/:amendmentId',
    name: 'amendment',
    component: AmendmentWorkspaceComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
  {
    path: '/GMS/Grant/Amendment/:amendmentType/:amendmentDetailId',
    name: 'amendmentDetail',
    component: AmendmentDetailWorkspaceComponent,
    meta: {
      allowedRoles: [
        appRoles.SuperAdmin,
        appRoles.SystemAdmin,
        appRoles.ProgramAdmin,
        appRoles.SecretariatMember,
        appRoles.Applicant,
        appRoles.Auditor
      ]
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// checks whether the requested route is secure
router.beforeEach((to, from, next) => {

  //@ts-ignore
  const isItABackButton = window.popStateDetected;
  //@ts-ignore
  window.popStateDetected = false;

  if (to.name !== from.name && !isItABackButton) {
    if (from.name) {
      navigationStack.push(from);
    } else {
      navigationStack.clear();
    }
  }
  if (to.matched.some(record => record.meta.isAnonymous)) {
    // this route not requires auth, 
    next();
  } else {
    if (to.name === "home") {
      next();
    } else {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      auth.isLoggedIn().then((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          auth.getUser().then((user: User) => {
            let userRoles = [];
            // handling multiple roles
            if (Array.isArray(user.profile.role_id)) {
              userRoles = userRoles.concat(user.profile.role_id);
            } else {
              userRoles.push(user.profile.role_id);
            }

            if (to.meta && to.meta.allowedRoles && to.meta.allowedRoles.filter(i => userRoles.indexOf(i) >= 0).length > 0) {
              const { can, cannot, rules } = new AbilityBuilder();

              roles.forEach(item => {
                if (userRoles.indexOf(item.roleId) >= 0) {
                  can(item.action, item.subject);
                }
              });

              Vue.prototype.$ability.update(rules);

              next();
            } else {
              next("/Unauthorized");
            }
          });
        } else {
          auth.login(to.fullPath);
        }
      });
    }
  }
});

export default router